import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { GET_ADMIN_DOWNLOAD_APPLICATION_FILE_PRESIGNED_QUERY_KEY } from '../../constants/queryKeys';
import { GET_ADMIN_DOWNLOAD_APPLICATION_FILE_PRESIGNED_URL } from '../../constants/apiUrls';
import { useCustomQuery } from '../utils/useCustomQuery';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface AdminDownloadApplicationFilePresignedResponse {
  fileStatus: string;
  fileName: string;
  url: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (res: AdminDownloadApplicationFilePresignedResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  fileUuid: string;
  enabled: boolean;
}

export const useGetAdminDownloadApplicationFilePresigned = ({
  onSuccess,
  onError,
  fileUuid,
  enabled,
}: Input) => {
  const getAdminDownloadApplicationFilePresigned = async () => {
    const res = await axiosClient.get<AdminDownloadApplicationFilePresignedResponse>(
      GET_ADMIN_DOWNLOAD_APPLICATION_FILE_PRESIGNED_URL(fileUuid)
    );
    return res.data;
  };

  return useCustomQuery(
    GET_ADMIN_DOWNLOAD_APPLICATION_FILE_PRESIGNED_QUERY_KEY.concat(fileUuid),
    getAdminDownloadApplicationFilePresigned,
    {
      onSuccess,
      onError,
      enabled,
    }
  );
};
